import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {customerRoutes, testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {composePath, noop, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function CustomersOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (isArray(rowId)) {
      return;
    }
    const path = composePath(customerRoutes.detail, {
      params: {id: rowId},
      isSearchParamsPreserved: false,
      queryParams: sourceSearchParams,
    });
    match(actionKey)
      .with('detail', () => navigate(path))
      .with('detail_newTab', () => window.open(path))
      .otherwise(noop);
  };

  return (
    <DmsDataGrid
      data-testid={testIds.customer.overview('datagrid')}
      gridCode="customer"
      actionCallback={actionCallback}
    />
  );
}
